export const collectAllPaginatedResults = async (fetchPage, pageSize = 100) => {
  const allItems = [];
  let skip = 0;
  let total = 0;

  while (true) {
    const response = await fetchPage(skip, pageSize);
    const items = Array.isArray(response)
      ? response
      : response?.items || response?.data?.items || response?.schools || response?.data?.schools || response?.users || response?.data?.users || [];

    if (Array.isArray(items)) {
      allItems.push(...items);
    }

    total = Number(response?.total ?? response?.data?.total ?? total ?? 0);

    if (items.length === 0 || allItems.length >= total || items.length < pageSize) {
      break;
    }

    skip += pageSize;
  }

  return { items: allItems, total };
};
